const styles = {
  thumbsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
    justifyContent: 'center'
  },

  thumb: {
    display: 'inline-flex',
    width: 800,
    height: 600,
    padding: 4,
    boxSizing: 'border-box',
  },

  thumbMobile: {
    display: 'inline-flex',
    width: 380,
    height: 300,
    padding: 4,
    boxSizing: 'border-box'
  },

  thumbInner: {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
  },
  img: {
    display: 'block',
    width: 'auto',
    height: '100%'
  }
};

export default styles;
